export default __webpack_public_path__ + "static/media/zido_2.a0ce2fa3.png";